import type { SubscriptionStatus, SubscriptionType } from "common/types";

import type { FunctionComponent, SVGProps } from "react";

import AgencyGradientIcon from "assets/icons/plans/agency-gradient.svg?react";
import AgencyOutlineIcon from "assets/icons/plans/agency-gradient-outline.svg?react";
import AvatarGradientIcon from "assets/icons/plans/avatar-gradient.svg?react";
import AvatarOutlineIcon from "assets/icons/plans/avatar-gradient-outline.svg?react";
import OutreachGradientIcon from "assets/icons/plans/outreach-gradient.svg?react";
import OutreachOutlineIcon from "assets/icons/plans/outreach-gradient-outline.svg?react";
import AgencyPlanIcon from "assets/icons/settings/agency-plan-icon.svg?react";
import AvatarPlanIcon from "assets/icons/settings/avatar-plan-icon.svg?react";
import OutreachPlanIcon from "assets/icons/settings/outreach-plan-icon.svg?react";

export const AGENCY_INCLUDED_SEATS =
  import.meta.env.MODE === "production" ? 20 : 2;

export const PRICING_PLANS: Record<
  SubscriptionType,
  {
    name: string;
    description: string;
    altDescription: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    gradientIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
    outlineIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
  }
> = {
  agency: {
    name: "Agency Plan",
    description: "Manage your clients' profiles across multiple workspaces",
    altDescription: "Manage your clients' accounts across multiple workspaces",
    icon: AgencyPlanIcon,
    gradientIcon: AgencyGradientIcon,
    outlineIcon: AgencyOutlineIcon,
  },
  user: {
    name: "Outreach Plan",
    description: "Grow your LinkedIn network with fully automated campaigns",
    altDescription:
      "Connect your LinkedIn profiles to Aimfox and start your outbound",
    icon: OutreachPlanIcon,
    gradientIcon: OutreachGradientIcon,
    outlineIcon: OutreachOutlineIcon,
  },
  rental: {
    name: "Avatar plan",
    description: "Scale your LinkedIn outreach with rented accounts",
    altDescription:
      "Rent and brand ready-to-go LinkedIn profiles. Scale your campaigns today!",
    icon: AvatarPlanIcon,
    gradientIcon: AvatarGradientIcon,
    outlineIcon: AvatarOutlineIcon,
  },
} as const;

export const SUBSCRIPTION_STATUSES: Record<SubscriptionStatus, string> = {
  in_trial: "Trial",
  active: "Active",
  non_renewing: "Non Renewing",
  cancelled: "Cancelled",
} as const;
